"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchDetailsSection = void 0;
const Text_1 = require("@amzn/atoz-web/Text");
const Theme_1 = require("@amzn/atoz-web/Theme");
const luxon_1 = require("luxon");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const PunchDetailsModalTypes_1 = require("./PunchDetailsModalTypes");
const PunchDetailsSection = ({ punchDetails }) => {
    var _a, _b, _c;
    const { t } = (0, react_i18next_1.useTranslation)();
    const actionDT = luxon_1.DateTime.fromISO(punchDetails.lastUpdatedDateTime.timestamp);
    const hasBeenEdited = JSON.stringify(punchDetails.createdDateTime) !==
        JSON.stringify(punchDetails.lastUpdatedDateTime);
    const punchSourceText = PunchDetailsModalTypes_1.punchSourceMap[punchDetails.punchSourceSystem];
    const punchSourceAndSiteIdText = !!punchSourceText && ((_a = punchDetails.punchLocation) === null || _a === void 0 ? void 0 : _a.siteId)
        ? `${punchSourceText} | ${(_b = punchDetails.punchLocation) === null || _b === void 0 ? void 0 : _b.siteId}`
        : punchSourceText || ((_c = punchDetails.punchLocation) === null || _c === void 0 ? void 0 : _c.siteId);
    const getSubmitterContent = (source, submitter) => {
        if (PunchDetailsModalTypes_1.showSubmitterResult.includes(source)) {
            return submitter;
        }
        else if (PunchDetailsModalTypes_1.showSystemInfo.includes(source)) {
            return t('time_and_attendance_PunchDetailsModal_PunchSource_System');
        }
        else if (PunchDetailsModalTypes_1.showUserAlias.includes(source)) {
            return t('time_and_attendance_PunchDetailsModal_PunchAction_Self');
        }
        else {
            return '';
        }
    };
    const submitterString = getSubmitterContent(punchDetails.punchSourceSystem, punchDetails.submitter.submitter);
    const getPunchDetailTextKey = (submitterString, hasBeenEdited) => {
        if (submitterString && hasBeenEdited) {
            return `time_and_attendance_PunchDetailsModal_PunchAction_EditedBy`;
        }
        else if (submitterString) {
            return `time_and_attendance_PunchDetailsModal_PunchAction_AddedBy`;
        }
        else if (hasBeenEdited) {
            return 'time_and_attendance_PunchDetailsModal_PunchAction_Edited';
        }
        else {
            return 'time_and_attendance_PunchDetailsModal_PunchAction_Added';
        }
    };
    const renderPunchDetailTextWithSubmitter = () => (react_1.default.createElement(react_i18next_1.Trans, { i18nKey: getPunchDetailTextKey(submitterString, hasBeenEdited), values: {
            submitter: submitterString,
            month: t(`time_and_attendance_PunchCard_daySelector_${actionDT.month}`),
            day: actionDT.day,
            year: actionDT.year,
            time: actionDT.toLocaleString(luxon_1.DateTime.TIME_SIMPLE)
        }, components: {
            submitter: react_1.default.createElement(Text_1.Span, { color: "neutral90" })
        } }));
    const renderPunchDetailTextWithoutSubmitter = () => (react_1.default.createElement(react_i18next_1.Trans, { i18nKey: getPunchDetailTextKey(submitterString, hasBeenEdited), values: {
            month: t(`time_and_attendance_PunchCard_daySelector_${actionDT.month}`),
            day: actionDT.day,
            year: actionDT.year,
            time: actionDT.toLocaleString(luxon_1.DateTime.TIME_SIMPLE)
        } }));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (punchDetails.punchSourceSystem || punchDetails.punchLocation) && (react_1.default.createElement(Text_1.H2, { fontSize: "T300", margin: { top: 'S400' }, dataTestId: "PunchSourceAndSiteId", fontWeight: 500 }, punchSourceAndSiteIdText)),
        react_1.default.createElement(PunchDetailText, { dataTestId: "PunchDetailText" },
            !!submitterString && renderPunchDetailTextWithSubmitter(),
            !submitterString && renderPunchDetailTextWithoutSubmitter())));
};
exports.PunchDetailsSection = PunchDetailsSection;
const PunchDetailText = (0, Theme_1.styledWithTheme)(Text_1.Text)(({ theme }) => `
    color:  ${theme.selectors.color('neutral80')};
    margin-top:  ${theme.selectors.space('S300')};
    fontSize: ${theme.selectors.fontSize('T200')} `);
